if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

function updatedSlider(swiper) {
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();
  swiper.slideTo(0);
  swiper.scrollbar.updateSize();
}


// custom jssss

// $(document).ready(function () {
//   $(".main-product-slick-slider").slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     fade: true,
//     infinite: false,
//     asNavFor: ".thumbnail-product-slick-slider",
//   });

//   $(".thumbnail-product-slick-slider").slick({
//     slidesToShow: 6,
//     slidesToScroll: 3,
//     asNavFor: ".main-product-slick-slider",
//     arrows: false,
//     infinite: false,
//     dots: false,
//     centerMode: false,
//     focusOnSelect: true,
//     responsive: [
//       {
//         breakpoint: 749,
//         settings: {
//           slidesToShow: 5,
//           slidesToScroll: 3,
//         },
//       },
//     ],
//   });
//   $(".main-product-slider ul.slick-initialized").show();
//   $(".thumbnail-product-slider ul.slick-initialized").show();
//   function filterSliders(dataVal) {
//     $(".main-product-slick-slider").slick("slickUnfilter");
//     $(".thumbnail-product-slick-slider").slick("slickUnfilter");
//     if (dataVal) {
//       $(".main-product-slick-slider").slick("slickFilter", function () {
//         return $(this).data("value") === dataVal;
//       });
//       $(".thumbnail-product-slick-slider").slick("slickFilter", function () {
//         return $(this).data("value") === dataVal;
//       });
//     }
//   }
//   var dataValdata = $(".main-product-slick-slider li").attr("data-value");
//   if (dataValdata) {
//     $(document).on("click", ".grouping-vari-click", function () {
//       var dataVal = $(this).attr("data-value");

//       filterSliders(dataVal);
//       if ($(".thumbnail-product-slick-slider li").length >= 6) {
//         $(".thumbnail-product-slick-slider")
//           .addClass("more-item")
//           .removeClass("less-item");
//       } else {
//         $(".thumbnail-product-slick-slider")
//           .addClass("less-item")
//           .removeClass("more-item");
//       }
//       $(".main-product-slick-slider").slick("refresh").slick('slickGoTo', 0);
//       $(".thumbnail-product-slick-slider").slick("refresh").slick('slickGoTo', 0);
//     });
//   }
//   if ($(".thumbnail-product-slick-slider li").length >= 6) {
//     $(".thumbnail-product-slick-slider").addClass("more-item");
//   } else {
//     $(".thumbnail-product-slick-slider").addClass("less-item");
//   }

//   $(".main-product-slick-slider").slick("refresh");
//   $(".thumbnail-product-slick-slider").slick("refresh");
//   $(".grouping-vari-click").first().click();
// });

$(document).ready(function () {
  $(".main-product-slick-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    infinite: false,
    asNavFor: ".thumbnail-product-slick-slider",
  });

  $(".thumbnail-product-slick-slider").slick({
    slidesToShow: 6,
    slidesToScroll: 3,
    asNavFor: ".main-product-slick-slider",
    arrows: false,
    infinite: false,
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
        },
      },
    ],
  });

  $(".main-product-slider ul.slick-initialized").show();
  $(".thumbnail-product-slider ul.slick-initialized").show();

  function filterSliders(dataVal) {
    $(".main-product-slick-slider").slick("slickUnfilter");
    $(".thumbnail-product-slick-slider").slick("slickUnfilter");

    if (dataVal) {
      const $mainSlides = $(".main-product-slick-slider li");
      const matchExists = $mainSlides.filter(function () {
        return $(this).data("value") === dataVal;
      }).length > 0;

      if (matchExists) {
        $(".main-product-slick-slider").slick("slickFilter", function () {
          return $(this).data("value") === dataVal;
        });
        $(".thumbnail-product-slick-slider").slick("slickFilter", function () {
          return $(this).data("value") === dataVal;
        });
      }
    }
  }

  var run_code = false;
  if ($(".main-product-slick-slider li").attr("data-value")) {
    var run_code = true;
  }else if($(".main-product-slick-slider li:nth-child(2)").attr("data-value")){
    var run_code = true;
  }


  if (run_code) {
    $(document).on("click", ".grouping-vari-click", function () {
      var dataVal = $(this).attr("data-value");
      filterSliders(dataVal);

      if ($(".thumbnail-product-slick-slider li").length >= 6) {
        $(".thumbnail-product-slick-slider")
          .addClass("more-item")
          .removeClass("less-item");
      } else {
        $(".thumbnail-product-slick-slider")
          .addClass("less-item")
          .removeClass("more-item");
      }

      $(".main-product-slick-slider").slick("refresh").slick('slickGoTo', 0);
      $(".thumbnail-product-slick-slider").slick("refresh").slick('slickGoTo', 0);
    });
  }

  if ($(".thumbnail-product-slick-slider li").length >= 6) {
    $(".thumbnail-product-slick-slider").addClass("more-item");
  } else {
    $(".thumbnail-product-slick-slider").addClass("less-item");
  }

  $(".main-product-slick-slider").slick("refresh");
  $(".thumbnail-product-slick-slider").slick("refresh");
  const $firstClick = $(".grouping-vari-click").first();
  const firstDataVal = $firstClick.data("value");
  const matchExists = $(".main-product-slick-slider li").filter(function () {
    return $(this).data("value") === firstDataVal;
  }).length > 0;

  if (matchExists) {
    $firstClick.click();
  }
});






document.addEventListener("DOMContentLoaded", () => {
  var swiper = new Swiper(".thumb-product-slider-r1", {
    spaceBetween: 50,
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesProgress: true,
    main: {
      swiper: swiper2,
    },
    breakpoints: {
      749: {
        slidesPerView: 'auto',
        spaceBetween: 25,
      },
    },
  });
  var swiper2 = new Swiper(".main-product-slider-r1", {
    effect: "fade",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
    on: {
      activeIndexChange: function(em) {
        setTimeout(function() {
          var slider_length = em.slides.length - 1;
          if(em.activeIndex == 0){
            $('.thumb-product-slider-r1').addClass('remove-before');
          }else{
            $('.thumb-product-slider-r1').removeClass('remove-before');
          }
          if(em.activeIndex == slider_length){
            $('.thumb-product-slider-r1').addClass('remove-after');
          }else{
            $('.thumb-product-slider-r1').removeClass('remove-after');
          }
        }, 500);
      }
    },
  });
});










